// from https://github.com/tomat/react-auto-scale
import React from 'react';
import PropTypes from 'prop-types';
import elementResizeEvent from 'element-resize-event';

const AutoScale = (props) => {
  const wrapperRef = React.useRef();
  const [wrapperSize, setWrapperSize] = React.useState({});
  React.useEffect(() => {
    const wrapper = wrapperRef.current;
    if (wrapper) {
      setWrapperSize({ width: wrapper.offsetWidth, height: wrapper.offsetHeight });
      elementResizeEvent(wrapper, () => {
        setWrapperSize({ width: wrapper.offsetWidth, height: wrapper.offsetHeight });
      });
      return () => elementResizeEvent.unbind(wrapper);  
    }
  }, [wrapperRef]);

  const contentRef = React.useRef();
  const [contentSize, setContentSize] = React.useState({});
  React.useEffect(() => {
    const content = contentRef.current;
    if (content) {
      const child = content.children[0];
      if (child) {
        setContentSize({ width: child.offsetWidth, height: child.offsetHeight });
        elementResizeEvent(child, () => {
          setContentSize({ width: child.offsetWidth, height: child.offsetHeight });
        });    
        return () => elementResizeEvent.unbind(child);  
      }
    }
  }, [contentRef]);

  const { maxHeight, maxWidth, maxScale } = props;

  let scale = (wrapperSize.width / (contentSize.width));
  if (maxHeight) {
    scale = Math.min(scale, (maxHeight / contentSize.height));
  }
  if (maxWidth) {
    scale = Math.min(scale, (maxWidth / contentSize.width));
  }
  if (maxScale) {
    scale = Math.min(scale, maxScale);
  }
  const containerHeight = (scale * contentSize.height);
  const containerWidth = (scale * contentSize.width);

  return (
    <div ref={wrapperRef} className={props.wrapperClass} style={props.style}>
      <div className={props.containerClass} style={{ maxWidth: '100%', width: containerWidth + 'px', height: containerHeight + 'px' }}>
        <div ref={contentRef} className={props.contentClass} style={{ transform: 'scale(' + scale + ')', transformOrigin: '0 0 0' }}>
          {React.Children.only(props.children)}
        </div>
      </div>
    </div>
  );
};

AutoScale.propTypes = {
  children: PropTypes.node,
  wrapperClass: PropTypes.string,
  containerClass: PropTypes.string,
  contentClass: PropTypes.string,
  maxHeight: PropTypes.number,
  maxWidth: PropTypes.number,
  maxScale: PropTypes.number,
}; 

AutoScale.defaultProps = {
  wrapperClass: '',
  containerClass: '',
  contentClass: '',
};

export default AutoScale;